const labels = {
  creationDate: 'Creation Date',
  anniversaryDate: 'Anniversary date',
  lastUpdate: 'Last Update',
  updateDate: 'Last Update',
  subject: 'Event Subject',
  fact: 'Event Fact',
  name: 'Name',
  publisherRefId: 'Publisher Ref ID',
  type: 'Type',
  recomendationDescription: 'Product recommendation description',
  software: 'Software',
  games: 'Games',
  casual: 'Casual',
  service: 'Service',
  searchBy: 'Search by',
  searchById: 'Search by ID',
  searchByIdName: 'Search by name or ID',
  searchByName: 'Search by name',
  searchByRuleName: 'Search by rule name',
  searchByEmail: 'Search by email',
  searchByIdEmail: 'Search by email or ID',
  searchByMarketPlaceOrderId: 'Search by marketPlaceOrderId',
  b2B: 'B2B',
  b2C: 'B2C',
  isoCode: 'Region Iso Code',
  status: 'Status',
  allStatusProducts: 'All Status Products',
  details: 'Details',
  enabled: 'Enabled',
  disabled: 'Disabled',
  ordering: 'Ordering',
  orderStatusCompleted: 'Completed',
  orderStatusPaymentPending: 'Payment Pending',
  orderStatusPaymentRefused: 'Payment Refused',
  orderStatusFraudPending: 'Fraud Pending',
  orderStatusPending: 'Pending',
  orderStatusPendingError: 'Pending with error',
  orderStatusCreated: 'Created',
  orderStatusCancelPending: 'Cancel Pending',
  orderStatusPartialCompleted: 'Partial Completed',
  orderStatusCanceled: 'Canceled',
  orderStatusCanceledError: 'Canceled with error',
  orderStatusPartialCanceled: 'Partial Canceled',
  orderStatusForceCompleted: 'Force-Completed',
  orderStatusForceCancelled: 'Force-Cancelled',
  orderStatusAborted: 'Aborted',
  orderStatusCancelAccepted: 'Cancel accepted',
  orderStatusNone: 'None',
  orderStatusInitialized: 'Initialized',
  orderStatusFailed: 'Failed',
  orderStatusExternalCompleted: 'External Completed',
  orderPaymentStatusCompleted: 'Completed',
  orderPaymentStatusPending: 'Pending',
  paymentType: 'Payment Type',
  storeId: 'Store ID',
  id: 'ID',
  destination: 'Destination',
  customer: 'Customer',
  orderStatus: 'Order status',
  notification_history_id: 'Notification history ID',
  email_body: 'Email body',
  webhook_payload: 'Webhook Payload',
  webhook_errors: 'Webhook Errors',
  notificationHistory_errors: 'Notification History Errors',
  processingDate: 'Processing Date',
  processedEvent: 'Event',
  receiverEmail: 'Receiver(s) email(s)',
  receiverUrl: 'Receiver URL (webhook)',
  webHook: 'Webhook Success Response',
  amount: 'Amount',
  store: 'Store',
  paymentID: 'Payment ID',
  lastPaymentIsOffline: 'Is Offline (last payment attempt)',
  paymentStatus: 'Payment Status',
  fraudStatus: 'Fraud Status',
  layoutStatus: 'Layout',
  fulfillment: 'Fulfillment',
  subscription: 'Subscription',
  email: 'Email',
  onlineStore: 'Online Store',
  companyName: 'Company Name',
  companyIEC: 'Company IEC',
  companyTIN: 'Company TIN',
  companyCNPJ: 'Company CNPJ',
  createStore: 'Create a store',
  orderID: 'Order ID',
  invoiceId: 'Invoice ID',
  invoiceIdExternal: 'Invoice ID (External)',
  currency: 'Currency',
  percentage: '%',
  applicableUntil: 'Applicable until',
  products: 'Products',
  country: 'Country',
  discountId: 'Discount Rule',
  sellingStores: 'Selling Stores',
  lifeTime: 'Life Time',
  trialAllowed: 'Trial Allowed',
  totalPrice: 'Total Price',
  totalAmount: 'Total Amount',
  total: 'Total',
  fullName: 'Full Name',
  userID: ' User ID',
  accountCreated: 'Account Created',
  productId: 'Product ID',
  currentProductId: 'Current Product ID',
  nextProductId: 'Next Product ID',
  catalogsId: 'Catalogs ID',
  catalogs: 'Catalogs',
  salesMode: 'Sales Mode',
  singleUse: 'Single Use',
  priority: 'Priority',
  family: 'Family',
  externalContext: 'External Context',
  decodedExtContext: 'Decoded Ext. Context',
  priceFunction: 'Price function',
  hostnames: 'Hostnames',
  storeHostname: 'Store Hostname',
  defaultLanguage: 'Default Language',
  salesLanguages: 'Sales Languages',
  enduserPortalTheme: 'Enduser Portal Theme',
  checkoutTheme: 'Checkout theme',
  checkoutFont: 'Checkout font',
  checkoutLayout: 'Checkout layout',
  checkoutTranslation: 'Checkout translation',
  paymentMethods: 'Available Payment methods',
  gtmId: 'GTM ID',
  updateReason: 'Update Reason',
  emailDate: 'Email Date',
  invoiceDate: 'Invoice Date',
  endUser: 'End User',
  address: 'Address',
  zipCode: 'Zip Code',
  transactionID: 'Transaction ID',
  installments: 'Installments',
  paymentDeadline: 'Payment Deadline',
  reseller: 'Reseller',
  onboarding: 'Onboarding',
  remittance: 'Remittance',
  product: 'Product',
  productSku: 'Product SKU',
  seller: 'Seller',
  sellerOnBehalf: 'Seller on Behalf',
  marketplaceStore: 'Marketplace Store',
  createInvoice: 'Create Invoice',
  orderConfirmation: 'Order confirmation',
  subscriptionUpgrade: 'Subscription Upgrade',
  subscriptionV1: 'Subscription v1',
  fulfillmentV1: 'Fulfillment v1',
  fulfillmentTemplates: 'Fulfillment templates',
  legalEntity: 'Legal Entity',
  subscriptionsModels: 'Subscriptions models',
  availablePayments: 'Available payments',
  blockedPayments: 'Blocked payments',
  maxPaymentsPart: 'Max payments part',
  oneClickPayment: 'One Click Payment',
  date: 'Date',
  startDate: 'Start Date',
  endDate: 'End Date',
  ruleName: 'Rule Name',
  ruleId: 'Rule Id',
  levels: 'Level(s)',
  sources: 'Source(s)',
  weight: 'Weight',
  discount: 'Discount',
  discountRuleId: 'Discount Rule ID',
  discountRuleName: 'Discount Rule Name',
  subscriptionIdInput: 'Subscription id',
  model: 'Model',
  discountAmount: 'Discount Amount',
  discountApply: 'Apply discount ?',
  maximumUses: 'Maximum Uses',
  user: 'User',
  application: 'Application',
  firstName: 'First name',
  lastName: 'Last name',
  userName: 'User name',
  privileges: 'Privileges',
  roles: 'Roles',
  metaRoles: 'Meta-Roles',
  profiles: 'Profiles',
  profilesIds: 'Profiles IDs',
  metaRolesIds: 'Meta-Roles IDs',
  fontFamily: 'Font Family',
  importCssRule: '@import css rule',
  themes: 'Themes',
  layouts: 'Layouts',
  translations: 'Translations',
  invoiceTranslations: 'Invoice translations',
  fonts: 'Fonts',
  markups: 'Markups',
  price: 'Price',
  priceId: 'Price Id',
  productName: 'Product name',
  value: 'Value',
  key: 'Key',
  msrp: 'MSRP',
  vatIncluded: 'VAT included',
  subscriptionModel: 'Subscription Model',
  trialDuration: 'Trial Duration in Days',
  fulfillmentTemplate: 'Fulfillment Template',
  licenseKeyPackages: 'License Key Packages',
  renewingProducts: 'Renewing Products',
  allowTrial: 'Allow trial',
  allowPaidTrial: 'Allow paid trial',
  preorderReleaseDate: 'Preorder Release Date',
  fulfillmentAndSubscription: 'Fulfillment & Subscription',
  general: 'General',
  prices: 'Prices',
  productsByParent: 'Products By Parent',
  productsByReference: 'Products By Reference',
  endUserGroups: 'End-User Groups',
  endUserGroup: 'End-User Group',
  endUserGroupId: 'End-User Group ID',
  countries: 'Countries',
  endUserMails: 'End-User Mails',
  maximumUsesPerStore: 'Maximum Uses Per Store',
  maximumUsesPerEndUser: 'Maximum Uses Per End-User',
  periodOfValidity: 'Period of Validity',
  delayVariable: 'Delay Variable',
  convertToTimeZone: 'Convert to time zone',
  validationField: 'This field is mandatory',
  validationEmptyLocales: 'No choice available (Store has no saleLocales !)',
  validationUrl: 'Please select a file',
  validationLabel: 'Please select asset label',
  validationEndDate: 'End date must be in the future',
  validationDuplicateLabel: 'There are several assets with the same label',
  salutation: 'Salutation',
  css: 'CSS',
  fallbackLocale: 'Fallback locale',
  catalog: 'Catalog',
  businessSegment: 'Business Segment',
  allBusinessSegment: 'All business Segment',
  strictB2B: 'STRICT B2B',
  strictB2C: 'STRICT B2C',
  physicalProduct: 'Physical Product',
  blockedCountries: 'Blocked Countries',
  localizedContent: 'Localized Content',
  productVariations: 'Product Variations',
  variation: 'Variation',
  productFiles: 'Product Files',
  backToParent: 'Back to Parent',
  discountLabels: 'Discount Labels',
  language: 'Language',
  discountLabel: 'Discount Label',
  byPercentage: 'By Percentage',
  byCurrency: 'By Currency',
  byFixedPrice: 'By fixed price',
  addAmountValueAndCurrency: 'Add amount value and currency',
  percents: 'Percents',
  code: 'Code',
  discountCode: 'Discount Code',
  cappingAndLimits: 'Capping And Limits',
  singleUseCodesGenerations: 'Single Use Codes Generations',
  remainingCodes: 'Remaining codes:',
  generationCodeLimit: 'Generate codes - 2000 max per generation',
  prevSaveGenerationCode:
    'You must save changes made to this discount rule in order to generate codes',
  endUserTypes: 'End User Types',
  endUserTypeSearching: 'End User type in searching',
  stores: 'Stores',
  save: 'Save',
  minimumCartAmount: 'Minimum Cart Amount',
  sepaOrderLimit: 'SEPA Order Limit',
  sepaOrderLimitResellers: 'SEPA Order Limit for Resellers',
  resellerId: 'Reseller ID',
  eligibility: 'Eligibility',
  localizedMarketingName: 'Marketing name',
  marketingId: 'Marketing Campaign ID',
  localizedShortDesc: 'Short description',
  localizedLongDesc: 'Long description',
  localizedThankYouDesc: ' Thank you page description',
  localizedPurchaseEmailDesc: 'Order confirmation email description',
  localizedManualRenewalEmailDesc: 'Manual renewal description',
  addLanguage: 'Add Language',
  selectFile: 'Select File',
  freeLabel: 'Free label',
  url: 'URL',
  dropFileOrSelect: 'Select files from your computer or click add icon to enter custom URL',
  relatedContents: 'Related Contents',
  resources: 'Resources',
  label: 'Label',
  rebate: 'Rebate',
  headerLogo: 'Header Logo',
  boxshot: 'Boxshot',
  icon: 'Icon',
  bundledProducts: 'Bundled products',
  variationParameters: 'Variation parameters',
  createDate: 'Create date',
  source: 'Source',
  sourceMarketplace: 'Source Marketplace',
  unpaidAmount: 'Unpaid Amount',
  salesFlags: 'Sales Flags',
  salesFlagsHelper: 'Sales flags are separated by spaces',
  termsOfUse: 'Terms of use',
  termsAndConditions: 'Terms & Conditions',
  ResellerContract: 'Reseller contract',
  numberOfInstallments: 'Number of installments',
  creditNote: 'Credit Note',
  creditNoteDate: 'Credit Note Date',
  emailAddress: 'Email Address',
  streetAddress: 'Street Address',
  city: 'City',
  zip: 'Zip',
  phone: 'Phone',
  ip: 'IP',
  endUserCountry: 'End user Country',
  paymentRequestDate: 'Payment Request Date',
  paymentDate: 'Payment Date',
  paymentProvider: 'Payment Provider',
  cardBin: 'Card Bin',
  paymentAttempt1_1: 'Payment Attempt 1/1',
  defaultCurrency: 'Default Currency',
  сurrency: 'Сurrency',
  priceCountry: 'Country',
  cancelOrder: 'Cancel Order',
  upsellPrice: 'Upsell price',
  crossSellPrice: 'Cross-sell price',
  overrideEmailSender: 'Override Email Sender',
  saleLanguages: 'Sale Languages',
  displayName: 'Display Name',
  storeWebsite: 'Store Website',
  installmentOptions: 'Installment Options',
  senderName: 'Sender Name',
  allowInstallments: 'Allow installments',
  restrictedCountries: 'Restricted Countries',
  allowedCountries: 'Allowed Countries',
  gtmIdOwnedByNexway: 'GTM ID (owned by Nexway)',
  forceEndUserCreation: 'Force End-user creation',
  promoteOneClickPayment: 'Promote one-click payment',
  displayProductDeliveryOnCheckoutConfirmation: 'Display product delivery on checkout confirmation',
  useMandateValue: 'Enable E-Mandates for India',
  enableRecipientCode: 'Enable Recipient Code',
  eligibleEndUserTypes: 'Eligible End User Types',
  allowQuotes: 'Allow Quotes',
  externalContextGenerationParamsOnePerLine: 'External Context Generation Params (one per line)',
  externalContextAlias: 'External Context Alias',
  useGeoIpToForceEnduserCountry: 'Use GeoIp to force Enduser country',
  fallbackCartCountry: 'Fallback Cart Country',
  resellerAuthentication: 'Reseller authentication',
  buyer: 'Buyer',
  prefillWith: 'Prefill with',
  buyerAuthentication: 'Buyer authentication',
  buyerDetails: 'Buyer details input mode',
  noAuthentication: 'No authentication',
  routes: 'Routes',
  design: 'Design',
  payment: 'Payment',
  enduserPortal: 'Enduser Portal',
  checkout: 'Checkout',
  resellerPortalEmbeddedCheckout: 'Reseller Portal embedded checkout',
  theme: 'Theme',
  layout: 'Layout',
  font: 'Font',
  i18n: 'I18n',
  paymentMethodsByDefault: 'Payment Methods by Default',
  blacklistedPaymentTypes: 'Blacklisted Payment Types',
  additionalPaymentTypes: 'Additional Payment Types',
  forcedPaymentTypes: 'Forced Payment Methods',
  paymentTabsRanking: 'Payment tabs ranking',
  paymentTabsRankingOnSsr: 'Payment tabs ranking on server side',
  group: 'Group',
  paymentTypes: 'Payment Types',
  assetsResource: 'Assets Resource',
  logoFavicon: 'Favicon',
  bannerInvoice: 'Invoice banner ',
  bannerOrderConfEmail: 'Confirmation email banner',
  logoStore: 'Logo',
  customerId: 'Customer ID',
  events: 'Events',
  clientId: 'Client ID',
  byProduct: 'By Product',
  marketingCampaign: 'Marketing Campaign',
  byParentProducts: 'By Parent Products',
  sourceProduct: 'Source Product',
  targetProducts: 'Target Products',
  recommendationName: 'Recommendation Name',
  recomendationId: 'Recommendation Id',
  crossSell: 'Cross Sell',
  upSell: 'Up Sell',
  upgrade: 'Upgrade',
  cart: 'Cart',
  carts: 'Carts',
  interstitial: 'Interstitial',
  purchase: 'Purchase',
  manualRenewal: 'Manual Renewal',
  recommendationsSelectionMode: 'Recommendations Selection Mode',
  fixedListOfProducts: 'Fixed List Of Products',
  productListAssociation: 'Product list association',
  marketingCampaignAssociation: 'Marketing campaign association',
  byParentProduct: 'By parent product',
  conditionsOfAvailabilty: 'Conditions Of Availabilty',
  rights: 'Rights',
  aggregatedRoles: 'Aggregated Roles',
  serviceName: 'Service Name',
  availableActions: 'Available Actions',
  customers: 'Customers',
  reasonForCurrentChange: 'Reason for current change',
  productNameOrId: 'Product name or ID',
  renewingNameOrId: 'Renewing product name or ID',
  parentNameOrId: 'Parent product name or ID',
  sourceNameOrId: 'Source product name or ID',
  targetNameOrId: 'Target product name or ID',
  targetProductName: 'Target Product Name or ID',
  targetMarketingCampaignName: 'Target Marketing Campaign Name',
  description: 'Description',
  clearances: 'Clearances',
  lastUpdateReason: 'Last Update Reason',
  role: 'Role',
  conditionsOfAvailability: 'Conditions of availability',
  privilege: 'Privilege',
  lifecycleId: 'Lifecycle ID',
  lifecycle: 'Lifecycle',
  enduserId: 'Enduser ID',
  subscriptionId: 'Subscription ID',
  subscriptionName: 'Subscription Name',
  contactEmailAddress: 'Contact Email Address',
  identification: 'Identification',
  permissions: 'Permissions',
  emails: 'Emails',
  modelId: 'Model ID',
  numDaysBeforeAnniversary: 'Number of days before anniversary',
  nextBillingDate: 'Next billing date',
  paymentServiceConfiguration: 'Payment Service Configuration',
  localizedContactPageUrl: "Localized contact page URL's",
  assets: 'Assets',
  cancelPeriod: 'Cancel period (in days, 0 or empty = no cancel period)',
  authenticationRealm: 'Authentication Realm',
  apiSecret: 'API Secret',
  realmName: 'Realm Name',
  salesReportDashboardURL: 'Dashboard External URL',
  test: 'Test',
  live: 'Live',
  remittableId: 'Remittable ID',
  features: 'Features',
  emailId: 'Email ID',
  managedCustomers: 'Managed Customers',
  secretKeys: 'Secret Keys',
  secretKey: 'Secret Key',
  secret: 'secret',
  secrets: 'secrets',
  deleteSecretKey: 'Delete Secret Key',
  add: 'Add',
  invoiceCreditNotesTypeOfId: 'Type of ID',
  invoiceCreditNotesId: 'ID',
  sgOrdersManagement: 'SG Order Management',
  resellerManagement: 'Reseller Management',
  onboardingManagement: 'Onboarding Management',
  remittanceManagement: 'Remittance Management',
  productManagement: 'Product Management',
  sellOnBehalf: 'Sell On Behalf',
  sendOrderConfirmationEmail: 'Send Order Confirmation Email',
  subscriptionUpgradeAuthorized: 'Subscription Upgrade Authorized',
  usingFulfillmentV1: 'Using Fulfillment V1',
  platformModules: 'Platform Modules',
  workflowAgreement: 'Workflow Agreement',
  technicalFeatures: 'Technical Features',
  forcedPaymentMethods: 'Forced Payment Methods',
  blackListedPaymentTypes: 'Blacklisted Payment Types',
  availableAdditionalPaymentTypes: 'Available Additional Payment Types',
  signedPartialAmountRequired: 'Signed Partial Amount Required',
  minPaymentAmountInPercent: 'Min Payment Amount in Percent',
  maxPaymentsParts: 'Max Payments Parts',
  paymentVendor: 'Payment Vendor',
  createEndUserWithoutSubscription: 'Create end-user without subscription',
  customerName: 'Customer Name',
  onboardingGuide: 'Onboarding Guide',
  onboardingTerms: 'Onboarding Terms',
  reports: 'Reports',
  notification: 'Notifications',
  notificationDefinitions: 'Notification Definitions',
  notificationHistory: 'Notification History',
  notificationsId: 'Notifications ID',
  notificationReceivers: 'Notification Receivers',
  notificationCustomer: 'Customer',
  notificationName: 'Name',
  notificationUrl: 'Url',
  notificationEmails: 'Emails',
  oneByLine: ' (one by line)',
  notificationEvents: 'Events',
  notificationStatus: 'Status',
  httpHeaders: 'HTTP Headers',
  oAuthConfiguration: 'OAuth 2.0 configuration',
  tlsConfiguration: 'TLS configuration',
  receiverType: 'Receiver Type',
  webhook: 'Webhook',
  targetedCustomers: 'Targeted Customers',
  contentTypeOneByLine: 'Content-type (one by line)',
  versionOneByLine: 'Version (one by line)',
  emailsOneByLine: 'Emails (one by line)',
  clientSecret: 'Client Secret',
  clientID: 'Client ID',
  tokenURL: 'Token URL',
  scopesOneByLine: 'Scopes(one by line)',
  TLSAuthMode: 'TLS Auth Mode',
  none: 'None',
  client: 'Client',
  server: 'Server',
  clientCertificates: 'Client Certificates',
  privateKey: 'Private Key',
  cACertificate: 'CA Certificate',
  notificationid: 'Notifications ID',
  notificationsHistory: {
    customer: 'Customer',
    processingDate: 'ProcessingDate',
    notificationHistoryId: 'Notification History ID',
    status: 'Status',
    event: 'Event',
    receiverEmail: 'Receiver(s) email(s)',
    receiverURL: 'Receiver URL (webhook)',
    webhookSuccessResponse: 'Webhook Success Response',
  },
  licenses: 'Licenses',
  last4Digits: 'Last four digits',
  licenseId: 'License ID',
  orderId: 'Order ID',
  orderLineId: 'Order line ID',
  locale: 'Locale',
  cpf: 'CPF',
  licenseProviderDefinition: 'License provider definition ID',
  validationNumber: 'Please put only numbers',
  publisherProductId: 'Publisher product ID',
  creationInProgress: 'Creation In Progress',
  creationFailed: 'Creation Failed',
  running: 'Running',
  canceled: 'Canceled',
  paused: 'Paused',
  expired: 'Expired',
  notificationHistoryId: 'Notification History ID',
  event: 'Event',
  webhookSuccessResponse: 'Webhook Success Response',
  cartId: 'Cart ID',
  checkoutUrl: 'Checkout URL',
  cartsUpdateDate: 'Update date',
  monitoringUpdateDate: 'Update Date',
  scheduledRemoval: 'Scheduled Removal',
  acquisition: 'Acquisition',
  genericName: 'Name',
  defaultLocale: 'Default Language',
  eventMatching: 'Event Matching',
  templating: 'Templating',
  mainIdJsonPath: 'JSON path to main ID',
  filters: 'Filters',
  inProgressUpper: 'IN PROGRESS',
  completed: 'COMPLETED',
  completedWithoutElement: 'COMPLETED WITHOUT ELEMENT',
  failedUpper: 'FAILED',
  jsonPath: 'JSON Path',
  resultNumbers: 'Result numbers',
  matchingRegex: 'Matching regexp',
  addFilter: 'Add filter',
  mailSubjectTemplate: 'Mail subject',
  mailBodyTemplate: 'Mail body',
  webHookPayloadTemplate: 'Webhook payload',
  licenseProviderDefinitionId: 'License Provider Definition ID',
  executionId: 'Execution ID',
  timeOfTheRequest: 'Time Of The request',
  requestOperation: 'Request operation',
  requestUserEmail: 'Request user email',
  processingDataLicenseId: 'Processing data license ID',
  quantity: 'Quantity',
  activationCodeKey: 'Activation Code/Key',
  licenseKey: 'License Key',
  vat: 'VAT',
  vatNumber: 'VAT number',
  taxOffice: 'Tax Office',
  taxIdNumber: 'Tax Id Number',
  identificationNumber: 'Identification number',
  net: 'Net',
  gross: 'Gross',
  netPrice: 'Net price',
  grossPrice: 'Gross price',
  vatAmount: 'Vat amount',
  discountedNetPrice: 'Net price discounted',
  discountedGrossPrice: 'Gross price discounted',
  vatDiscountAmount: 'VAT amount discounted',
  transactionId: 'Transaction ID',
  subscriptionStatus: 'Subscription Status',
  creditNoteId: 'Credit Note ID',
  cancelationReasons: 'Cancelation Reasons',
  preorder: 'Preorder',
  splitPayment: 'Split Payment',
  customerStatus: 'Customer Status',
  informativeDPStatus: 'Estimated Payment status',
  billingPlan: 'Billing plan',
  TYPUpgrade: 'Thank you page “Upgrade”',
  offer: 'Offer',
  init: 'Init',
  pendingReview: 'Pending Review',
  pending: 'Pending',
  pendingCapture: 'Pending Capture',
  pendingRefund: 'Pending Refund',
  accepted: 'Accepted',
  captured: 'Captured',
  error: 'Error',
  failed: 'Failed',
  cancelled: 'Cancelled',
  refunded: 'Refunded',
  partialRefunded: 'Partial Refunded',
  chargeback: 'Chargeback',
  chargebackReversed: 'Chargeback Reversed',
  refused: 'Refused',
  success: 'Success',
  failure: 'Failure',
  initialized: 'Initialized',
  creationPending: 'Creation Pending',
  creationFailure: 'Creation Failure',
  creationAccepted: 'Creation Accepted',
  cancelPending: 'Cancel Pending',
  cancelFailure: 'Cancel Failure',
  cancelAccepted: 'Cancel Accepted',
  chargebackAlert: 'Chargeback Alert',
  chargeBack: 'ChargeBack',
  doubleOrder: 'Double Order',
  disappointingProduct: 'Disappointing Product',
  disappointingService: 'Disappointing Service',
  fraudSuspicion: 'Fraud Suspicion',
  orderCancellation: 'Order Cancellation',
  outOfStock: 'Out Of Stock',
  partnersCancellationRequest: 'Partners Cancellation Request',
  priceSubscriptionEvolution: 'Price Subscription Evolution',
  productTechnicalIssue: 'Product Technical Issue',
  subscriptionFlexibility: 'Subscription Flexibility',
  technicalIssue: 'Technical Issue',
  unsettledTransactions: 'Unsettled Transactions',
  unwillingSubscription: 'Unwilling Subscription',
  vatIssue: 'VAT Issue',
  wrongProductChoice: 'Wrong Product Choice',
  yes: 'Yes',
  no: 'No',
  usingLicenseKeyProvider: 'Using license key provider',
  withFulfillmentSample: 'Fulfillment sample',
  themeRefCheckoutname: 'Checkout theme ref name',
  themeRefCheckoutcustomerId: 'Checkout theme ref customer ID',
  themeRefEndUserPortalname: 'Enduser Portal theme ref name',
  themeRefEndUserPortalcustomerId: 'Enduser Portal ref customer ID',
  operationDetails: 'Operation Details',
  httpConfiguration: 'HTTP Configuration',
  enable: 'Enable',
  disable: 'Disable',
  testMode: 'TestMode',
  format: 'Format',
  baseUrl: 'Base URL',
  urlComplement: 'URL Complement',
  bodyTemplate: 'Body Template',
  activationCode: 'Activation Code',
  responsePaths: 'Response Paths',
  conversionTemplate: 'Conversion Template',
  downloadExpireDate: 'Download ExpireDate',
  downloadUrl: 'Download URL',
  errorMessage: 'Error Message',
  errorStatusCodesOnePerLine: 'Error status codes (one per line)',
  errorProductPerAndSub:
    'A product cannot have permanent lifetime while being linked to a subscription model',
  errorProductFulAndBun: 'This product has fulfillment model, it cannot be a bundle',
  contentType: 'Content Type',
  aAuth2_0Configuration: 'OAuth 2.0 configuration',
  tokenUrl: 'Token URL',
  tlsAuthMode: 'TLS Auth Mode',
  caCertificate: 'CA Certificate',
  serverCACertificates: 'CA Certificate',
  testModeHTTPConfiguration: 'Test mode HTTP configuration',
  baseUrlTest: 'Base URL (Test)',
  operationExecutions: 'Operation Executions',
  fulfillmentPackages: 'Fulfillment Packages',
  autoFulfillments: 'Auto Fulfillments',
  manualFulfillments: 'Manual Fulfillments',
  licenseProviderDefinitions: 'License Provider Definitions',
  packageId: 'Package ID',
  available: 'Available',
  blacklisted: 'Blacklisted',
  occupied: 'Occupied',
  renewed: 'Renewed',
  threshold: 'Threshold',
  providerDefinitionId: 'Provider Definition ID',
  definitionName: 'Definition Name',
  inProgress: 'In Progress',
  done: 'Done',
  occuredAt: 'Occured at',
  delayMn: 'Delay (min)',
  delay: 'Delay',
  abandonedCart: 'Abandoned Cart',
  abandonedCarts: 'Abandoned Carts',
  account: 'Account',
  orders: 'Orders',
  endUsers: 'End-users',
  сustomer: 'Customer',
  applyingReseller: 'Applying reseller',
  pendingPostRegistrationReseller: 'Pending post registration reseller',
  approvedReseller: 'Approved reseller',
  declinedReseller: 'Declined reseller',
  login: 'Login',
  endUserId: 'End-user ID',
  consentStatus: 'Marketing consent status',
  termsAndConditionsConsentDate: 'T&Cs consent date',
  orderDate: 'Order Date',
  sentAt: 'Sent at',
  priceFunctionId: 'Price Function ID',
  priceFunctionName: 'Price Function Name',
  from: 'From',
  to: 'To',
  roleId: 'Role ID',
  rolesIds: 'Roles IDs',
  campaignId: 'Campaign ID',
  coupon: 'Coupon',
  campaign: 'Campaign',
  singleUseCode: 'Single use code',
  subscriptionPlan: 'Subscription plan',
  recurring: 'Recurring',
  paymentMethod: 'Payment method',
  subscriptionModels: 'Subscription models',
  resellers: 'Resellers',
  pendingApprovals: 'Pending approvals',
  pendingPostRegistration: 'Pending post registration',
  approved: 'Approved',
  declined: 'Declined',
  approving: 'Approving',
  approvedInError: 'Approved in error',
  waitingEmailValidation: 'Waiting for email verification',
  allowedBlockedCountries: 'Allowed/Blocked Countries',
  blocked: 'Blocked',
  allowed: 'Allowed',
  selectAll: 'Select All',
  removeAll: 'Remove All',
  catalogsAndProducts: 'Catalogs & products',
  managedCustomerId: 'Managed Customer ID',
  managedCustomer: 'Managed Customer',
  identityId: 'Identity ID',
  linkedCustomerId: 'Linked Customer ID',
  linkedCustomer: 'Linked Customer',
  notifications: 'Notifications',
  marketingAbandoned: 'Marketing Abandoned',
  marketingCampaigns: 'Marketing Campaigns',
  customerslist: 'Customers list',
  discountrules: 'Discount rules',
  enduserlist: 'Enduser list',
  endusergroups: 'Enduser groups',
  users: 'Users',
  'notification-definition': 'Notification Definition',
  'notification-history': 'Notification History',
  orderlist: 'Order list',
  order: 'Order',
  subscriptions: 'Subscriptions',
  recommendations: 'Recommendations',
  templateId: 'Template ID',
  version: 'Version',
  firstMailingDate: 'First Mailing Date',
  tags: 'Tags',
  locales: 'Locales',
  fallbackLanguage: 'Fallback language',
  areYouSureYouWantToDeleteTheStore: 'Are you sure you want to delete the store?',
  areYouSureYouWantToDeleteTheStores: 'Are you sure you want to delete the store(s)?',
  areYouSureYouWantToDeleteTheProduct: 'Are you sure you want to delete the product?',
  areYouSureYouWantToDeleteTheProducts: 'Are you sure you want to delete the product(s)?',
  areYouSureYouWantToDeleteTheCurrencie: 'Are you sure you want to delete the currency?',
  areYouSureYouWantToDeleteTheCurrencies: 'Are you sure you want to delete the currencie(s)?',
  areYouSureYouWantToDeleteTheLocale: 'Are you sure you want to delete the locale?',
  areYouSureYouWantToDeleteTheLocales: 'Are you sure you want to delete the locale(s)?',
  areYouSureYouWantToDeleteTheCountry: 'Are you sure you want to delete the country?',
  areYouSureYouWantToDeleteTheCountries: 'Are you sure you want to delete the countrie(s)?',
  areYouSureYouWantToDeleteTheSubsidiary: 'Are you sure you want to delete the subsidiary?',
  areYouSureYouWantToDeleteTheSubsidiaries: 'Are you sure you want to delete the subsidiarie(s)?',
  areYouSureYouWantToDeleteTheVariation: 'Are you sure you want to delete the variation?',
  areYouSureYouWantToDeactivateTheUsers: 'Are you sure you want to deactivate the user(s)?',
  thisActionIsIrreversibleDoYouConfirmIt: 'This action is irreversible, do you confirm it?',
  confirm: 'Confirm',
  cancel: 'Cancel',
  emailbuilder: 'Email Builder',
  editor: 'Editor',
  sampleData: 'Sample Data',
  mergedSample: 'Merged Sample',
  lastSeenSample: 'Last Seen Sample',
  customSample: 'Custom Sample',
  renderedHtml: 'Rendered HTML',
  htmlCode: 'HTML code',
  body: 'Body',
  subj: 'Subject',
  cloneTemplate: 'Clone template',
  saveSample: 'Save Custom Sample',
  storeForTemplate: 'Store on which the new template will apply',
  leaveUnset: 'Leave unset to apply template on all stores ...',
  customerNotFound: 'Customer not found',
  audits: 'Audits',
  audit: 'Audit',
  delta: 'Delta',
  who: 'Who',
  what: 'What',
  where: 'Where',
  customerOfUser: 'Customer of user',
  userId: 'User ID',
  userType: 'User type',
  userIp: 'User IP',
  subjectId: 'Subject ID',
  operation: 'Operation',
  subjectType: 'Subject type',
  subjectCustomer: 'Subject customer',
  platform: 'Platform',
  auditItemId: 'Audit item ID',
  reasonOfOperation: 'Reason of operation',
  paymentAttempt: 'Payment attempt',
  accountStatus: 'Account status',
  remittable: 'Remittable',
  jwtBearer: 'JWT Bearer',
  internalCall: 'Internal Call',
  internal: 'Internal',
  fullRemote: 'Full remote',
  pricingRemote: 'Pricing remote',
  variantPricingRemote: 'Variant pricing remote',
  signed: 'Signed',
  shared: 'Shared',
  standart: 'Standart',
  singleUse_v1: 'Single use',
  after: 'after',
  between: 'between',
  runningDate: 'Running Date',
  anonymous: 'Anonymous',
  parameters: 'Parameters',
  addNewParameter: 'Add new parameter',
  newParameter: 'New Parameter',
  pricefunctions: 'Price functions',
  variables: 'Variables',
  productFields: 'Product fields',
  expression: 'Expression',
  field: 'Field',
  min: 'Min',
  max: 'Max',
  defaultValue: 'Default value',
  translation: 'Translation',
  data: 'Data',
  invoicetranslations: 'Invoice Translations',
  invoiceTranslation: 'Invoice Translation',
  defaultRanking: 'Default ranking',
  dataBegining: 'Data (beginning)',
  crudHelperResources: 'C.R.U.D. Helper resource list',
  resourceUrlEndpoint: 'Resource URL / Endpoint',
  extraParams: 'Extra parameters',
  validation: 'validation',
  customerType: 'Customer type',
  specificRanking: 'Specific ranking',
  blacklistedPaymentMethodsByLayout: 'Blacklisted Payment Types By Layout',
  exportAll: 'Export all',
  exportNotUsed: 'Export not used',
  exportUsed: 'Export used',
  newProduct: 'New product',
  newVariation: 'New variation',
  newPrice: 'New price',
  serviceConfiguration: 'Service Configuration',
  dpTheme: 'DP Theme',
  allowSubscriptionUpgrade: 'Allow subscription upgrade',
  allowCartLoadingInIframe: 'Allow cart loading in iframe',
  allowPasswordlessLogin: 'Allow passwordless login',
  useSenderEmailFromSubsidiary: 'Use Sender E-mail from Subsidiary',
  allowedDomains: 'Allowed domains',
  expirationDate: 'Expiration date',
  suspend: 'Suspend',
  resume: 'Resume',
  hierarchy: 'Hierarchy',
  subProducts: 'Sub Product',
  inactive: 'Inactive',
  active: 'Active',
  batches: 'Batches',
  productByReference: 'Product by reference',
  manualFulfillment: 'Manual fulfillment',
  batchId: 'Batch ID',
  uploadedAt: 'Uploaded at',
  fields: 'Fields',
  parameterName: 'Parameter Name',
  displayString: 'Display String',
  path: 'Path',
  associatedCustomer: 'Associated Customer',
  resetPasswordTokenLifespan: 'Reset password token lifespan (in ms)',
  jwtPublicKey: 'JWT Public Key',
  realm: 'Realm',
  identitiesForRealm:
    'Unless overriden at identity level, identities related to this realm will be able to manage these customers, in addition to the customer directly associated to this realm.',
  searchSection: 'Search section...',
  applyOnNetPrice: 'Apply on Net Price',
  discountLevel: 'Discount Level',
  testOrder: 'Test Order',
  marketingCampaignId: 'Marketing Campaign ID',
  parameter: 'Parameter',
  parameterDisplaySettings: 'Parameter display strings',
  values: 'Values',
  valueLabel: 'Value label',
  duplicate: 'Duplicate',
  attributes: 'attributes',
  relatedProduct: 'Related product',
  formatError: 'Can only be letters, digits and underscores',
  currencies: 'Currencies',
  local: 'Local',
  alpha2Code: 'Alpha 2 code',
  alpha3Code: 'Alpha 3 code',
  numericCode: 'Numeric code',
  zipCodeStatus: 'Zip code status',
  inEEC: 'in EEC',
  mandatory: 'Mandatory',
  optional: 'Optional',
  valid: 'Valid',
  inEU: 'in EU',
  legalName: 'Legal Name',
  subsidiaryId: 'Subsidiary ID',
  subsidiary: 'Subsidiary',
  subsidiaries: 'Subsidiaries',
  subsidiaryRules: 'Subsidiary Rules',
  external: 'External',
  adress1: 'Adress 1',
  adress2: 'Adress 2',
  informations1: 'Informations 1',
  informations2: 'Informations 2',
  countryIso2: 'Country ISO 2',
  countryIso3: 'Country ISO 3',
  companyCode: 'Company Code',
  taxCode: 'Tax Code',
  exemptionPolicy: 'Exemption Policy',
  avalaraConfig: 'Use Avalara',
  timeZone: 'Time Zone',
  marketplaceOrderId: 'Market Place Order ID',
  marketplaceOrderStatus: 'Market Place Order Status',
  marketplace: 'Market Place',
  endUserPrice: 'End-user Price',
  sort: 'Sort',
  lastDay: 'Last 24h',
  lastWeek: 'Last 7 days',
  lastMonth: 'Last 30 days',
  lastYear: 'Last year',
  thisMonth: 'This month',
  thisYear: 'This year',
  customRange: 'Custom Range',
  dateRange: 'Date range',
  filterBy: 'Filter by',
  exportOfFilteredPrices: 'Export Of Filtered Prices',
  importOfFilteredPrices: 'Import File',
  filterByNameOrIdProduct: 'FILTER BY NAME/ID PRODUCT',
  filterByPublisherRefId: 'FILTER BY PUBLISHER REF ID',
  listOfProductNamesOrProductsIds: 'List of Products IDs',
  productNamesStartBy: 'Product Names Separated By Comma',
  listOfPublisherRefID: 'List of Publisher Ref IDs',
  publisherRedIDStartBy: 'Publisher Ref IDs Separated By Comma',
  provider: 'Provider',
  activationLink: 'Activation link',
  attachQRCodeToEmail: 'Attach QR code to email',
  twoFAStatus: 'Two-factor Authentication',
  twoFAInputCode: '6 digits code',
  twoFASecretKey: 'Your secret code',
  midTermUpgrade: 'MidTerm Upgrade',
  usingSafePIIData: 'Using Safe PII Data',
  suspendSubscriptionsOnEndUserDeletion: 'Suspend subscription when end-user deleted',
  mandatoryRemotePrice: 'Mandatory Remote Price',
  overrideExpirationDate: 'Allow Override Expiration Date',
  remotePriceAllowed: 'Remote Price Allowed',
  true: 'True',
  false: 'False',
  subscriptionGenerations: 'Subscription generation(s)',
  importCSVFileName: 'File Name',
  importCSVStartAt: 'Import Start At',
  importCSVFinishAt: 'Import Finish At',
  importCSVStatus: 'Status',
  importCSVDetails: 'Details',
  startImport: 'START IMPORT',
  onProgress: 'ON PROGRESS',
  startExportCSV: 'Start Export',
  exportCSVCustomer: 'Customer',
  exportCSVStartDate: 'Start Date',
  export: 'Customer',
  finished: 'FINISHED',
  created: 'CREATED',
  updated: 'UPDATED',
  eventMainObjectId: 'Event Main Object Id',
  searchByEventMainObjectId: 'by Event Object Id',
  eventSubject: 'Event Subject',
  retryCount: 'Retries Count',
  retryLeft: 'Retries Left',
  processedSuccessfully: 'Processed successfully',
  retry: 'Retry',
  notification_definition_name: 'Notification Definition name',
  avaTaxStatus: 'Ava tax Status',
  lifeCycleStatus: 'Life cycle status',
  emailConfirmationStatus: 'Email confirmation status',
  fulfillmentStatus: 'Fulfillment status',
  registerPaymentMethodStatus: 'Register payment method status',
  endUserCreationStatus: 'End-user creation status',
  electronicInvoiceStatus: 'Electronic invoice status',
  invoiceStatus: 'Invoice status',
  prebillingStatus: 'Prebilling status',
  detailedOrderStatus: 'Detailed Order Status',
  noPaymentAttemptsFound: 'No Payment Attempts Found',
  getOfferTitle: 'Don`t cancel your subscription and get ',
  saveOfferTittle: 'Don`t cancel your subscription and save ',
  yourDiscount: 'your {{discountRate}} discount ',
  renewalOf: 'on the next renewal of ',
  nameForLifeTime: '{{name}} for {{lifeTime}}',
  renewalDiscount: 'Next renewal including discount:',
  oldOfferPrice: '{{currency}} {{grossPrice}}',
  newOfferPrice:
    '<span class="newPrice">{{currency}} {{discountedGrossPrice}}</span> <strong>for {{lifeTime}}</strong>',
  forLifeTime: 'for {{lifeTime}}',
  offerVatDiscountAmount: '(incl. {{currency}} {{vatDiscountAmount}} taxes)',
  offerSubTitle:
    'If you cancel your subscription, you will have full protection until {{expirationDate}}. After that date, your subscription will end you will not be changed for any subsequent periods.',
  offerDescription:
    'Shortly before the end of the current subscription term, you will be charged a subscription payment with discount using the payment method linked to your subscription. Your subscription will be automatically renewed for the next term. We will send you an email reminder of the upcoming payment. All subsequent subscription auto-renewals will be changed at the price in effect at the time of the renewal, without discount.',
  dontPayRightNow: 'You don`t pay anything right now.',
  howToCancelSub:
    'You can cancel your subscription at any time through your customer account, or by contacting Customer Support.',
  discountAvailable: 'Discount available',
  discountAlreadyApplied: 'Discount already applied',
  offerApplied: 'Discount is applied to the next renewal, order ID: {{orderId}}',
  offerCantBeApplied: 'Discount can not be applied to the subscription',
  offerIsNotAvailable: 'Offer not available for this subscription',
  getOffer: 'Check for Offer',
  applyOffer: 'Apply discount ',
  message: 'Message',
  vendorId: 'Vendor ID',
  paymentId: 'Payment ID',
  orderNumber: 'Order Number',
  paymentTypeId: 'Payment Type ID',
  paymentOffline: 'Payment Off Line',
  magicCardDetected: 'Magic Card Detected',
  oldStatus: 'Old Status',
  newStatus: 'New Status',
  trial: 'Trial',
  actionRequired: 'Action Required',
  delayToNotify: 'Delay To Notify',
  broker: 'Broker',
  invoice: 'Invoice',
  sessionId: 'Session Id',
  paymentRequestType: 'Payment Request Type',
  context: 'Context',
  titleForEventsAdditionalData: 'Events Additional Data',
  updatePricesInMarketingCampaigns: 'Update Prices',
  priceRoundingRules: 'Price rounding rules',
  rule1: 'Rule 1',
  rule2: 'Rule 2',
  customPriceRounding: 'Custom price rounding',
  applyDiscountAndBeautifier: 'Apply discount and beautifier on unit price',
  addCurrency: 'Add currency',
  copyMessage: 'Copy message',
  additionalProperties: 'Additional Properties',
  fiscalReceiptNumber: 'Fiscal Receipt Number',
  fnNumber: 'Fn Number',
  shiftNumber: 'Shift Number',
  fiscalDocumentNumber: 'Fiscal Document Number',
  uuid: 'UUID',
  fiscalDocumentAttribute: 'Fiscal Document Attribute',
  ofReceiptUrl: 'Of Receipt Url',
  receipt_datetime: 'Receipt Date Time',
  filePath: 'File Path',
  renewal: 'Renewal {{number}}',
  customFields: 'Custom Fields',
  boolean: 'Boolean',
  string: 'String',
  integer: 'Integer',
  customerOwningTheNewTemplate: 'Customer owning the new template',
  taxesExempted: 'Taxes exempted',
  taxesExemption: 'Taxes exemption',
  licenseExpiration: 'License Expiration',
  remotePriceTitle: 'Remote Price',
  TVA: 'TVA',
  remotePriceUrl: 'Remote Price Url',
  wallet: 'Wallet',
  paymentMethodType: 'Payment method type',
  bin: 'BIN',
  linkedSubscriptions: 'Linked subscriptions',
  areYouSureYouWantToDeleteThePaymentMethods:
    'Are you sure you want to delete these payment methods?',
  areYouSureYouWantToDeleteThePaymentMethod: 'Are you sure you want to delete this payment method?',
  manageEmails: 'Manage Emails',
  manageNotifications: 'Manage Notifications',
  cumulativity: 'Cumulativity',
  exportStatus: 'Export status',
  exportFilters: 'Filters',
  discountPlanTag: 'Discount Plan Tag',
  discountPlanStep: 'Discount Plan Step',
  discountPlanIgnorePurchaseDiscount: 'Ignore Purchase Discount',
  isGift: 'Gift Product',
  draft: 'Draft',
  archived: 'Archived',
  lastUpdater: 'Last Updater',
  onboardingCustomerRole: 'Role',
  onboardingCustomerRoleTemplate: 'Role template',
  onboardingDisable: 'Onboarding is disabled',
  additionalFieldsMapping: 'Additional Fields Mapping',
  fieldName: 'Field name',
  responsePath: 'Response path (JSON/XML path)',
  supportedOperations: 'Supported Operations',
  templateDetail: 'Template detail',
  businessModel: 'Business model',
  endUserType: 'Enduser type',
  useDate: 'Use date',
  commandName: 'Command name',
  numberOfRetries: 'Number of retries',
  useDeeplink: 'Use Deeplink',
  deeplinkDuration: 'Deeplink duration (seconds)',
  deeplinksingleUse: 'Single Use',
  ordersExportModalTitle: 'Export File',
  ordersExportModalFirstText: 'You will download all the results',
  ordersExportModalSecondText: 'This may take a few minutes.',
  ordersExportModalThirdText:
    ' You will be redirected to a page where you can download the file once ready.',
  ordersExportModalButton: 'Confirm export',
  extendExpDate: 'Extend expiration date',
  newExpDate: 'New expiration date',
  extendExpDateModalTitle: 'Extend expiration date',
  discountRules: 'Discount Rules',
  ofdReceiptUrl: 'Receipt URL',
  receiptDatetime: 'Receipt Date',
  templateName: 'Template Name',
  templateDefinitionName: 'Template Definition Name',
  recipient: 'Recipient',
  dryRun: 'Dry Run',
  caseSensitive: 'Case Sensitive',
  resellerPin: 'Reseller PIN',
  externalId: 'External Id',
  all: 'All',
  abandoned: 'Abandoned',
  prebillingInitialized: 'Prebilling Initialized',
  prebillingFailed: 'Prebilling Failed',
  prebillingCompleted: 'Prebilling Completed',
  chargeAttemptInitialized: 'Charge Attempt Initialized',
  chargeAttemptFailed: 'Charge Attempt Failed',
  generalCounters: 'General Counters',
  maxRetryReached: 'Max Retry Reached',
  clickToResetPrices: 'Click this button to reset prices',
  clickToInheritPrices: 'Click this button to inherit prices from the parent product',
  template: 'Template',
  byInvoiceNumber: 'By invoice number',
  otherFilters: 'Other filters',
  invoiceNumbers: 'Invoice Numbers',
  countriesRegions: 'Countries & Regions',
  proformaId: 'Proforma ID',
  productRecoId: 'Product reco Id',
  fixedUpgradePrices: 'Fixed upgrade prices',
  fixedUpgradePricesDesc:
    'The following table represents all configured fixed upgrade prices for reco',
  targetProductId: 'Target Product Id',
  startAt: 'Starts at',
  endAt: 'Ends at',
  noPricesFound: 'No prices found',
  isPartiallyRefundable: 'Partially Refundable',
  recurringStartDate: 'Recurring Start Date',
  recurringEndDate: 'Recurring End Date',
  nonRecurringPaymentMethod: 'Non Recurring Payment Method',
  metadata: 'Metadata',
  lastError: 'Last Error',
  skipPrebillingEmail: 'Skip Prebilling Email',
  replayedTransactionId: 'Replayed Transaction Id',
  reasonCode: 'Reason Code',
  reasonText: 'Reason Text',
  paymentMethodId: 'Payment Method Id',
  asyncContext: 'Async Context',
  amountToRefund: 'Amount To Refund',
  transactions: 'Transactions',
  cancellationReason: 'Cancellation Reason',
  additionalQueryParams: 'Additional Query Params',
  removeAllSecretsDialog: 'Are you sure you want to delete all the secrets?',
  secretKeyCreationTitle: 'Secret Key Generated:',
  secretKeyCreationContent:
    'Please copy and store this key locally as you will not be able to retrieve it later',
  view: 'View',
  unifiedRegisterSoftware: 'Unified register software',
  refund: 'Refund',
  partialRefund: 'Partial Refund',
  exportList: 'Export list',
  exportSearch: 'Search',
  refundSummary: 'Refund Summary',
  refundType: 'Refund Type',
  refundMode: 'Refund Mode',
  fullRefund: 'Full Refund',
  refundPartAmount: 'Refund of part of the amount',
  automaticCalculation: 'Automatic Calculation',
  semiManualCalculation: 'Semi-manual Calculation',
  licenseStartDate: 'License Start Date',
  notApplicable: 'N/A',
  validate: 'Validate',
  continue: 'Continue',
  back: 'Back',
  prevError: 'Previous error',
  prev: 'Prev',
  next: 'Next',
  nextError: 'Next error',
  includeCreditNotes: 'Include credit notes',
};

export default labels;
